const UnitConstants = {
    CURRENCY: 1,
    METRE: 2,
    SQUARE_METRE: 3,
    CUBIC_METRE: 4,
    LITRE: 5,
    PERCENT: 6,
    PICOLITER: 7,
    ENERGY: 8, // kWh/m2/year
    KILOGRAM: 9,
    NUMBER: 10,
    EPC_TOTAL: 11, // kWh/year
    SQUARE_METRE_PER_YEAR: 12
}

export default UnitConstants